<template>
  <div id="shop_layout" class="shop_layout">
    <shop-nav />
    <div>
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
import ShopNav from './ShopNav.vue';
import merchantAPI from "../../api/merchantAPI";



export default {
  components: { ShopNav },
  provide(){
    return{
      merchant: this.merchant
    }
  },
  data(){
    return {
      merchant:{},
    };
  },
  mounted(){
    // this.getMerchant();
    // if remark pass it else existing one
    const merchant = this.$store.getters["merchants/getCurrentMerchant"](this.$route.params.accountId);
    this.$store.dispatch("merchants/get",{
      accountId:this.$route.params.accountId,
      remarks: this.$route.query.remarks || merchant?.remarks,
    });
    this.$store.dispatch("catalog/getCategories");
  },
  watch:{
    '$route.params.accountId'(){
      const merchant = this.$store.getters["merchants/getCurrentMerchant"](this.$route.params.accountId);
      this.$store.dispatch("merchants/get",{
        accountId:this.$route.params.accountId,
        remarks: this.$route.query.remarks || merchant?.remarks,
      });
      this.$store.dispatch("catalog/getCategories");
    },
  },
  async created() {
    // await this.getMerchant();
  },
  methods:{



  },
}
</script>

<style lang="scss">
// globally applied styles
.shop_layout{
  min-width: 320px;
  font-size: var(--fs-lg);

  // global css classes
  .shop_page{
    padding: 0 20px;
  }
  .shop_label{
    font-weight: 600;
    color: var(--txt-secondary);
    margin-bottom: var(--space-small);
    word-break: break-word;
    white-space: break-spaces;
  }
  .px_md{padding-left: 10px; padding-right: 10px;}
  .py_md{padding-top: 10px; padding-bottom: 10px;}
  .section_gap_x{margin-left: 3%; margin-right: 3%;}
  .section_gap_y{margin-top: 25px; margin-bottom: 25px;}

  .sp_title_lg{ font-size: 1.8rem;}
  .sp_title_md { font-size: 1.6rem;}

  .divider{border-bottom: 1px solid #EEEEEE;}
  .section_divider{
    border: 2px solid #EEEEEE;
  }
  .input_field{
    font-family: 'Figtree', sans-serif;
    line-height: 1.4;
    color: #1F1F1F;
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 16px;
    input, textarea{
      &::placeholder{
        color: #B8B8B8;
      }
    }
  }
}
</style>

<style>
.shop_layout .multiselect__placeholder{
  color: #B8B8B8;
}
.shop_layout .word_break{
    word-break: break-word;
    white-space: break-spaces;
}
</style>